import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

type Props = {
  asBanner: boolean;
  children: string;
};

export const CalendarSyncCardHeader: React.VFC<Props> = ({ asBanner, children }) => {
  if (asBanner) {
    return (
      <Typography2 variant="bodyPrimary" component="strong">
        {children}
      </Typography2>
    );
  }

  return <h3>{children}</h3>;
};
